/*@ngInject*/
export default [() => ({
  restrict: 'A',
  require: 'ngModel',
  link: (scope, elm, attrs, ctrl) => {
    ctrl.$validators.fourByteCharacter = (modelValue) => {
      const isInvalidChar =  /[\u{10000}-\u{10FFFF}]/u.test(modelValue);
      return !isInvalidChar;
    };

  }
})];
